export default __webpack_public_path__ + "static/4-60825bdfdae91c2b3ef7c84d8f6ac6c6.jpeg";